import { createFileRoute } from "@tanstack/react-router";
import AdminPartsSync from "@/pages/admin/AdminPartsSync";

export const Route = createFileRoute("/_adminLayout/admin/parts-sync")({
  component: AdminPartsSync,
});
